export const FETCH_STUDY_YEARS = "FETCH_STUDY_YEARS";

export const INSERT_STUDY_YEAR = "INSERT_STUDY_YEAR";

export const DELETE_STUDY_YEAR = "DELETE_STUDY_YEAR";

export const EDIT_STUDY_YEAR_INFO = "EDIT_STUDY_YEAR_INFO";
